var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.50049 18.75V5.25C5.50049 4.85218 5.65852 4.47064 5.93983 4.18934C6.22113 3.90804 6.60266 3.75 7.00049 3.75H13.0005C13.3983 3.75 13.7798 3.90804 14.0611 4.18934C14.3425 4.47064 14.5005 4.85218 14.5005 5.25V18.75H5.50049Z",
    stroke: "url(#paint0_linear_1798_40753)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 11.25H4C3.60218 11.25 3.22064 11.408 2.93934 11.6893C2.65804 11.9706 2.5 12.3522 2.5 12.75V17.25C2.5 17.6478 2.65804 18.0294 2.93934 18.3107C3.22064 18.592 3.60218 18.75 4 18.75H5.5",
    stroke: "url(#paint1_linear_1798_40753)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4995 9H15.9995C16.3973 9 16.7789 9.15804 17.0602 9.43934C17.3415 9.72064 17.4995 10.1022 17.4995 10.5V17.25C17.4995 17.6478 17.3415 18.0294 17.0602 18.3107C16.7789 18.592 16.3973 18.75 15.9995 18.75H14.4995",
    stroke: "url(#paint2_linear_1798_40753)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 6.75H11.5",
    stroke: "url(#paint3_linear_1798_40753)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 9.75H11.5",
    stroke: "url(#paint4_linear_1798_40753)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 12.75H11.5",
    stroke: "url(#paint5_linear_1798_40753)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 15.75H11.5",
    stroke: "url(#paint6_linear_1798_40753)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1798_40753",
    x1: 10.0005,
    y1: 3.75,
    x2: 10.0005,
    y2: 18.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9472E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6246A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1798_40753",
    x1: 4,
    y1: 11.25,
    x2: 4,
    y2: 18.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9472E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6246A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1798_40753",
    x1: 15.9995,
    y1: 9,
    x2: 15.9995,
    y2: 18.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9472E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6246A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1798_40753",
    x1: 10,
    y1: 6.75,
    x2: 10,
    y2: 7.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9472E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6246A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1798_40753",
    x1: 10,
    y1: 9.75,
    x2: 10,
    y2: 10.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9472E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6246A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1798_40753",
    x1: 10,
    y1: 12.75,
    x2: 10,
    y2: 13.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9472E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6246A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1798_40753",
    x1: 10,
    y1: 15.75,
    x2: 10,
    y2: 16.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9472E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6246A2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountsIcon);
export default __webpack_public_path__ + "static/media/accounts-icon.a3419b952676fe774f0193919e7952e6.svg";
export { ForwardRef as ReactComponent };